<template>
<div class="invoices">

    <div>

        <p>Records of your purchases for your convenience.</p>

        <table v-if="invoices.length>0">
            <thead>
                <tr>

                    <th>Date</th>
                    <th>Invoice</th>
                    
                    <th class="mobile-hide">Product</th>

                    <th>Amount</th>
                    <th class="mobile-hide">Status</th>
                    

                </tr>
            </thead>
            <tbody>
                <!-- <tr v-for="invoice in invoices" :key="invoice.invoice_id" @click="$router.push({name:'invoice-page',params:{number:invoice.invoice_serial_number}})"> -->
                <tr v-for="invoice in invoices" :key="invoice.invoice_id" @click="$router.push({name:'invoice-page',params:{number:invoice.invoice_serial_number}})">

                    <td>
                        <time>{{invoice.creation_formatted}}</time>
                    </td>

                    
                    <td class="invoice-number" >
                        <span>{{invoice.invoice_serial_number}}</span>
                        <a>View <i class="icon icon-chevron-right"></i></a>
                    </td>
                    

                    <td class="mobile-hide">
                        <span v-if="invoice.product_name">{{invoice.product_name}}</span>
                        <span v-else>{{invoice.title}}</span>
                    </td>

                    <td>
                        <span>${{numberWithCommas(invoice.amount)}}</span>
                    </td>

                    <td class="mobile-hide last-column">
                        <span v-if="invoice.status=='8'">
                            Paid
                        </span>
                        <span v-else-if="invoice.status=='6'||invoice.status=='7'">
                            Pending
                        </span>
                        <span v-else>
                            Incomplete
                        </span>
                    </td>

                    

                </tr>
            </tbody>
        </table>
        <div v-else>
            <h3>
                You currently have no invoices
            </h3>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import store from "@/store"
import Utility from "@/mixins/Utility";

export default {
    name: "Invoices",

    mixins: [
        Utility
    ],


    beforeRouteEnter(to, from, next) {
        store.dispatch("loadInvoices").then(function () {
            next();
        });

    },

    computed: {

        ...mapGetters(["invoices"])
    }
}
</script>
